import Content from "@routes/Keyword/templates/AseanInsights/components/Content";
import VideoBackground from "@routes/Keyword/templates/AseanInsights/components/VideoBackground";
import { cn } from "@util/helpers";

type LeadReportProps = {
  /** This is the classname of the component. */
  className?: string;
  /** The URL of the attachment do be viewed/downloaded. */
  attachmentURL: string;
};

/**
 * The lead report component for the Asean Insights template.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20436-71279&m=dev
 */
const LeadReport = ({
  className,
  attachmentURL,
}: LeadReportProps): React.ReactElement => {
  return (
    <div
      data-testid="lead-report-component"
      className={cn("bg-[#1e1e1e]", className)}
    >
      <div className="relative mx-auto h-[700px] w-[1440px] max-w-full overflow-hidden lg:h-[606px]">
        <VideoBackground />

        <Content attachmentURL={attachmentURL} />
      </div>
    </div>
  );
};

export default LeadReport;
